if (!customElements.get('share-button')) {
    customElements.define('share-button', class ShareButton extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          copyButton: this.querySelector('button.share-button__copy'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input')
        }
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
        this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));


      }

    copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        this.elements.successMessage.classList.remove('hidden');
        this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
        setTimeout(()=>{
            this.elements.successMessage.classList.add('hidden');
        },1500);
        });
    }
    updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
    }
    });
}